import { useTranslation } from 'react-i18next';

export default function VoucherPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa fa-ticket" /> {t('Vouchers', 'Vouchers')}
        </h1>
      </div>
      <div className="form-card">
        <div className="empty-state">
          <i className="fa fa-ticket" style={{ fontSize: 48, marginBottom: 12, display: 'block', color: 'var(--mod-voucher)' }} />
          <p>Vouchers module — create and redeem vouchers.</p>
          <p className="text-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
}
